// REACT
import * as React from 'react';

// ROUTER
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

// UTILS
import { constants } from '../constants/index';

// ROUTE COMPONENTS
import NotFound from 'containers/NotFound';
import ProServiceModules from 'containers/ServiceContainer/ProServiceModules';
import Consultations from 'containers/Consultations';
import ConsultCountdown from 'containers/ConsultCountdown';
import HelpFeedback from 'containers/HelpFeedback/HelpFeedback';
import App from 'containers/App';

// PROVIDER COMAPNY COMPONENTS
import CompanyContainer from 'containers/CompanyContainer/index';
import CompanySetupForm from 'containers/CompanyContainer/CompanySetupForm';
import EmployeeSetupForm from 'containers/CompanyContainer/EmployeeSetupForm';
import ServiceSetupForm from 'containers/CompanyContainer/ServiceSetupForm';
import AdminSetupForm from 'containers/CompanyContainer/AdminSetupForm';

// PROVIDER COMPONENTS
import ProviderContainer from 'containers/ProviderContainer/index';

// ALL ROUTES ASSUME YOU ARE AUTHENTICATED
export default withRouter(props => (
    <Switch>
        <Route exact path="/" component={ProServiceModules} />
        <Route exact path={`/modules`} component={ProServiceModules} />
        <Route
            path={`/modules/service/:clientUid?/:serviceId?`}
            component={ProServiceModules}
        />
        {/* TODO: CREATE A NEW COMPONENT TO USE HERE*/}
        <Route path="/consultations/:id" component={Consultations} />
        <Route path="/check-back-soon/:id" component={ConsultCountdown} />
        <Route path="/help+feedback" component={HelpFeedback} />
        <Route path="/provider/dashboard/:id" component={ProviderContainer} />
        {/* TODO: GROUP ALL OF THE COMPANY ROUTES UNDER A SINGLE COMPONENT */}
        <Route path="/company/dashboard" component={CompanyContainer} />
        <Route path="/company/adminSetup" component={AdminSetupForm} />
        <Route path="/company/companyEditor" component={CompanySetupForm} />
        <Route path="/company/companyEditor/:id" component={CompanySetupForm} />
        <Route path="/company/employeeEditor" component={EmployeeSetupForm} />
        <Route
            path="/company/employeeEditor/:id"
            component={EmployeeSetupForm}
        />
        <Route path="/company/serviceEditor" component={ServiceSetupForm} />
        <Route path="/company/serviceEditor/:id" component={ServiceSetupForm} />
        <Route component={ProServiceModules} />
        {/* TODO: ADD A DECENT PAGE NOT FOUND INSTEAD TO THE REDIRECT TO THE PROVIDER HOME PAGE ABOVE */}
    </Switch>
));



// WEBPACK FOOTER //
// ./src/js/routes/ProviderRoutes.jsx